import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useTranslation } from 'react-i18next';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const email = params.get("email");

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await apiFetch("/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, email, password })
      });
      setSuccess(true);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  if (success) {
    return (
      <div className="auth-page">
        <img src="/dragon-logo.png" alt="DragonFit" className="auth-logo" />
        <h1 className="auth-title neon-text">DragonFit</h1>
        <p className="auth-subtitle">{t('reset_password.subtitle')}</p>
        <h2 style={{ marginTop: 20 }}>{t('reset_password.success_title')}</h2>
        <p style={{ marginTop: 20, textAlign: "center" }}>
          {t('reset_password.success_desc')}
        </p>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <img src="/dragon-logo.png" alt="DragonFit" className="auth-logo" />
      <h1 className="auth-title neon-text">DragonFit</h1>
      <p className="auth-subtitle">{t('reset_password.subtitle')}</p>

      <h2 style={{ marginTop: 20 }}>{t('reset_password.title')}</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder={t('reset_password.placeholder')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input"
          style={{ marginBottom: 20 }}
        />
        <button className="btn btn-primary w-full" disabled={loading}>
          {loading ? <span className="loading-spinner"></span> : t('reset_password.change_btn')}
        </button>
      </form>
    </div>
  );
};

export default ResetPasswordPage;
